import { atomFamily, selectorFamily } from "recoil";
import uniqBy from "lodash/uniqBy";
import { getGameTemplates } from "api/ProviderApi";

const loadGameTemplateList = selectorFamily({
    key: "LoadGameTemplateList",
    get: ({ userId }) => async () => {
        const response = await getGameTemplates(userId);
        return response.body;
    },
});

export const gameTemplateListState = atomFamily({
    key: "GameTemplateListState",
    default: loadGameTemplateList,
});

export const getGameTypes = selectorFamily({
    key: "GetGameTypes",
    get: ({ userId }) => ({ get }) => {
        const gameTemplatesList = get(gameTemplateListState({ userId }))
        return uniqBy(gameTemplatesList, "gameType");
    }
})